import { render, staticRenderFns } from "./ReferenceDetailsController.vue?vue&type=template&id=14f336ef&"
import script from "./ReferenceDetailsController.vue?vue&type=script&lang=js&"
export * from "./ReferenceDetailsController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports